<template>
    <div class="basket-card">
        <a :href="result.detailPage" v-if="result.picture" class="basket-card__image">
            <img :src="result.picture.src" :alt="result.picture.alt">
        </a>
        <div class="basket-card__description">
            <div class="basket-card__header">
                <p v-if="result.article" class="basket-card__article">{{result.article}}</p>
                <a :href="result.detailPage" class="def-title-6">{{result.name}}</a>
                <!--<sku-select v-if="screenWidth < 992" />-->
                <div v-if="screenWidth >= 992 || screenWidth < 768" class="basket-card__price-block">
                    <p v-if="(screenWidth >= 992 || screenWidth < 768) && result.price.discountPercent" class="def-price prosentText">{{result.price.printDiscountPercent}}</p>
                    <p v-if="result.price" class="def-price">{{result.price.printPrice || result.price.price}}</p>
                    <p v-if="result.price && +result.price.price !== +result.price.priceOld" class="def-price-old">
                        {{result.price.printPriceOld || result.price.priceOld}}
                    </p>
                    <p class="basket-card__save" v-if="result.price.printDiscount">{{ result.price.printDiscount }}</p>
                </div>
            </div>
            <!--
            <div v-if="screenWidth >= 992">
                <sku-select />
            </div>
            -->

            <div v-if="screenWidth < 992 && screenWidth >= 768" class="basket-card__price-block">
                <p v-if="screenWidth < 992 && screenWidth >= 768 && result.price.discountPercent" class="def-price prosentText">{{result.price.printDiscountPercent}}</p>

                <p v-if="result.price" class="def-price">{{result.price.printPrice || result.price.price}}</p>
                <p v-if="result.price && +result.price.price !== +result.price.priceOld" class="def-price-old">
                    {{result.price.printPriceOld || result.price.priceOld}}
                </p>
                <p class="basket-card__save" v-if="result.price.printDiscount">{{ result.price.printDiscount }}</p>
            </div>

            <div class="basket-card__counter">
                <DefCounter :result="result" />
            </div>
            <div class="def-price basket-card__price-big">
                {{result.price.printPrice || result.price.price}}
            </div>
            <svg @click="deleteProduct()" class="basket-card__delete">
                <use xlink:href="#svg-close"></use>
            </svg>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
    name: 'BasketCard',
    selector: '.basket-card',
    props: {
        result: {
            type: Object,
            default: () => ({
                "id": "50655",
                "name": "Каблучка з емаллю",
                "detailPage": "/catalog/119158420101/",
                "article": "50655",
                "price": {
                    "price": '4322',
                    "printPrice": '4 322 ₴',
                    "printPriceOld": '6 785 ₴',
                    "priceOld": '6785'
                },
                "offer": {
                    "id": "50686",
                    "price": {
                        "price": 0,
                        "printPrice": "0 грн."
                    },
                    "current": true
                },
                "offers": [
                    {
                        "id": "50686",
                        "price": {
                            "price": 0,
                            "printPrice": "0 грн."
                        },
                        "current": true
                    },
                    {
                        "id": "50685",
                        "price": {
                            "price": 0,
                            "printPrice": "0 грн."
                        },
                        "current": false
                    },
                    {
                        "id": "50684",
                        "price": {
                            "price": 25068,
                            "printPrice": "25068 грн."
                        },
                        "current": false
                    },
                    {
                        "id": "50683",
                        "price": {
                            "price": 0,
                            "printPrice": "0 грн."
                        },
                        "current": false
                    },
                    {
                        "id": "50682",
                        "price": {
                            "price": 0,
                            "printPrice": "0 грн."
                        },
                        "current": false
                    },
                    {
                        "id": "50681",
                        "price": {
                            "price": 0,
                            "printPrice": "0 грн."
                        },
                        "current": false
                    },
                    {
                        "id": "50680",
                        "price": {
                            "price": 0,
                            "printPrice": "0 грн."
                        },
                        "current": false
                    }
                ],
                "propsForCheck": {
                    "SIZES": {
                        "16": {
                            "name": "16",
                            "displayValue": "16",
                            "value": "16",
                            "disable": null,
                            "active": null,
                            "type": "img"
                        },
                        "17": {
                            "name": "17",
                            "displayValue": "17",
                            "value": "17",
                            "disable": null,
                            "active": null,
                            "type": "img"
                        },
                        "18": {
                            "name": "18",
                            "displayValue": "18",
                            "value": "18",
                            "disable": null,
                            "active": null,
                            "type": "img"
                        },
                        "15_5": {
                            "name": "15,5",
                            "displayValue": "15_5",
                            "value": "15_5",
                            "disable": null,
                            "active": true,
                            "type": "img"
                        },
                        "16_5": {
                            "name": "16,5",
                            "displayValue": "16_5",
                            "value": "16_5",
                            "disable": null,
                            "active": null,
                            "type": "img"
                        },
                        "18_5": {
                            "name": "18,5",
                            "displayValue": "18_5",
                            "value": "18_5",
                            "disable": null,
                            "active": null,
                            "type": "img"
                        },
                        "17_5": {
                            "name": "17,5",
                            "displayValue": "17_5",
                            "value": "17_5",
                            "disable": null,
                            "active": null,
                            "type": "img"
                        }
                    }
                },
                "picture": {
                    "alt": "119158420101",
                    "src": "/local/templates/love-you/images/crash_photo.jpeg"
                },
                "basket_id": "122492",
                "count": 1
            })
        },
        dataLayer: {
            type: Object
        }
    },
    methods: {
        ...mapActions({
            basketRemove: 'basket/remove',
        }),
        deleteProduct() {
            const id = this.result?.offer?.id || this.result.id;
            this.basketRemove({ id });
            this.handlerClickGoogle(id);
        },
        handlerClickGoogle(removeId) {
            try {

                const product = this.dataLayer.data[removeId];
                // console.log(product);
                dataLayer.push({
                    'ecommerce': {
                        'currencyCode': this.dataLayer.currencyCode,
                        'remove': {
                            'products': [{
                                'name': product.name,
                                'id': product.id,
                                'price': product.price,
                                'brand': 'Love you',
                                'category': product.category,
                                'variant': product.variant,
                                'position': product.position,
                            }]
                        }
                    },
                    'event': 'gtmUaEvent',
                    'gtmUaEventCategory': 'Enhanced Ecommerce',
                    'gtmUaEventAction': 'Removing a Product from a Shopping Cart',
                    'gtmUaEventNonInteraction': 'False'
                });
            } catch (err) {
                console.error(err);
            }
        },
    },
}
</script>

<style lang="scss">
    .def-price.prosentText {
        width: 100%;
        color: #D80D44;
        font-weight: 500;
    }
    .basket-card{
        display: grid;
        grid-template-columns: 54px 1fr;
        position: relative;
        background-color: #fff;
        margin-bottom: 4px;
        @include point-md{
            grid-template-columns: 88px 1fr;
        }
        &__delete{
            position: absolute;
            top: 8px;
            right: 8px;
            width: 16px;
            height: 16px;
            fill: #757575;
            @include point-md{
                top: 17px;
                right: 17px;
            }
            @include point-lg{
                top: 50%;
                transform: translateY(-50%);
                right: 24px;
            }
            &:hover{
                cursor: pointer;
            }
        }
        &__image{
            display: flex;
            justify-content: center;
            align-items: flex-start;
            padding-top: 16px;
            @include point-md{
                padding: 12px;
            }
            @include point-lg{
                align-items: center;
            }
            img{
                display: block;
                max-width: 40px;
                @include point-md{
                    max-width: 55px;
                }
            }
        }
        &__description{
            display: grid;
            grid-template-columns: 1fr;
            padding: 16px 16px 16px 0;
            @include point-md{
                grid-template-columns: 1.5fr 1fr 1fr;
                padding: 12px 12px 12px 0;
            }
            @include point-lg{
                grid-template-columns: 1.5fr 1fr .8fr .7fr;
            }
        }
        &__article{
            font-size: rem(12);
            line-height: 100%;
            color: #757575;
            margin-bottom: 4px;
            order: 1;
        }
        &__price-block{
            display: flex;
            align-items: center;
            order: 3;
            flex-wrap: wrap;
            margin-bottom: 16px;
            @include point-md{
                order: unset;
                margin-bottom: 0px;
            }
            @include point-lg{
                align-items: flex-end;
                order: 3;
            }
            .def-price{
                font-size: rem(14);
                margin-right: 8px;
            }
            .def-price-old{
                font-size: rem(12);
                margin-right: 10px;
            }
        }
        &__save{
            font-size: rem(12);
            color: var(--text-colour-secondary);
        }
        &__counter{
            display: flex;
            align-items: center;
            margin-bottom: 16px;
            @include point-md{
                justify-content: flex-end;
                margin-bottom: 0px;
            }
            @include point-lg{
                justify-content: center;
            }
        }
        &__price-big{
            display: flex;
            align-items: center;
            @include point-md{
                justify-content: flex-end;
            }
            @include point-lg{
                justify-content: unset;
                padding-right: 52px;
            }
        }
        .sku-selects{
            margin-bottom: 0;
            max-width: 250px;
            @include point-lg{
                max-width: unset;
            }
        }
        &__header{
            display: flex;
            flex-direction: column;
            @include point-md{
                grid-column-start: 1;
                grid-column-end: 4;
            }
            @include point-lg{
                grid-column-start: 1;
                grid-column-end: 2;
            }
            .sku-selects{
                margin-bottom: 15px;
                order: 4;
                @include point-md{
                    order: 3;
                }
                @include point-lg{
                    order: unset;
                }
            }
        }
        .def-title-6{
            line-height: 115%;
            margin-bottom: 8px;
            order: 2;
            forn-size: rem(14);
            @include point-md{
                forn-size: rem(16);
            }
            @include point-lg{
                margin-bottom: 12px;
            }
        }
    }
</style>